var map = {
	"./add.svg": "c2a3",
	"./alter_delete.svg": "2d60",
	"./dashboard.svg": "f782",
	"./dataMgt.svg": "9151",
	"./directionLeft.svg": "54dd",
	"./disabled.svg": "2ef9",
	"./down.svg": "d681",
	"./enabled.svg": "55b5",
	"./filedownload.svg": "39ea",
	"./home.svg": "6bbe",
	"./log-out.svg": "30fb",
	"./lossDetail.svg": "8eb8",
	"./lossMgt.svg": "b214",
	"./permission.svg": "3979",
	"./questionMgt.svg": "8e44",
	"./report.svg": "9e5c",
	"./search.svg": "8e8d",
	"./select.svg": "064a",
	"./setting.svg": "05ff",
	"./user.svg": "b3b5",
	"./user1.svg": "5a8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";